import React from "react";
import MobilePage, { PageContainer } from "../../../Components/MobilePage";
import AppBar from "../../../../Webshop/Mobile/Components/AppBar";
import CategoryList from "../PackageList/Components/CategoryList";
import { useLocation } from "react-router-dom";
import useRoutes from "../../../hooks/useRoutes";
import BuyCataloguesDialog from "../../../Components/BuyCataloguesDialog";

const CategoryListPage = () => {
  const location = useLocation();
  const routes = useRoutes();

  console.log("The location is", location);

  return (
    <MobilePage>
      <AppBar />
      <PageContainer>
        <CategoryList />
      </PageContainer>

      {routes["products.catalogues"].path == location.pathname && (
        <BuyCataloguesDialog />
      )}
    </MobilePage>
  );
};

export default CategoryListPage;
